// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
// TODO: Add SDKs for Firebase products that you want to use in the future
// https://firebase.google.com/docs/web/setup#available-libraries

// Environment variable validation
const requiredEnvVars = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID'
];

// App Check is optional but recommended for production

// Check for missing required environment variables
const missingEnvVars = requiredEnvVars.filter(envVar => !process.env[envVar]);
if (missingEnvVars.length > 0) {
  const errorMessage = `Missing required Firebase environment variables: ${missingEnvVars.join(', ')}. 
Please check your .env.local file and ensure all Firebase configuration variables are set.
Copy .env.example to .env.local and add your Firebase project values.`;
  console.error('[Firebase] Configuration Error:', errorMessage);
  throw new Error(errorMessage);
}

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID // Optional
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics with error handling
let analytics = null;
try {
  analytics = getAnalytics(app);
  console.log('[Firebase] Analytics initialized successfully');
} catch (error) {
  console.warn('[Firebase] Analytics initialization failed:', error);
  console.warn('[Firebase] Analytics features will be disabled');
}

// Initialize Firebase Authentication
const auth = getAuth(app);

// Initialize Google Auth Provider
const googleProvider = new GoogleAuthProvider();

// Initialize Cloud Firestore
const db = getFirestore(app);

// Initialize App Check for abuse protection
let appCheck = null;
try {
  if (process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY) {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(
        process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY
      ),
      isTokenAutoRefreshEnabled: true
    });
    console.log('[Firebase] App Check initialized with reCAPTCHA Enterprise');
  } else if (process.env.NODE_ENV === 'development') {
    // In development, App Check can be skipped or use debug provider
    console.log('[Firebase] App Check skipped in development mode');
    console.log('[Firebase] Add REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY for production protection');
  } else {
    console.warn('[Firebase] App Check not initialized - add REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY for production security');
  }
} catch (error) {
  console.warn('[Firebase] App Check initialization failed:', error);
  console.warn('[Firebase] Continuing without App Check protection');
}

// Export for use in other parts of your app
export { app, analytics, auth, googleProvider, db, appCheck };
